<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-13 14:56:52
 * @LastEditTime: 2022-02-16 14:12:25
 * @Description:
 -->
<template>
  <div class="threeD-page">
    <ul class="tab-title clear">
      <li v-for="(item, index) in $route.meta.threeDList" :key="index" :class="{ active: current === index + 1 }"
        @mouseenter="loaded && (current = index + 1)" @mouseleave="loaded && (current = 0)"
        @click="$router.push(`${$route.path}/${item.path}`)">
        <span class="s1"><em class="num">{{ index + 1 }}</em>{{ item.meta.title }}</span>
        <p>查看详情</p>
        <dl>
          <dd v-for="(subitem, subindex) in item.children.filter(
            i => i.path
          )" :key="subindex">
            {{ subitem.meta.title }}
          </dd>
        </dl>
      </li>
    </ul>
    <div class="canvas-box">
      <p>安装顺序</p>
      <canvas @mousemove="handleMouseMove" ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const MAX_OPACITY = 0.5;
const STEP = 0.02;
const WIDTH = 1323,
  HEIGHT = 936;
export default {
  data() {
    return {
      opacity: 0,
      current: -2 // vApp与资源2项均未加载完成
    };
  },
  computed: {
    loaded: vm => vm.current >= 0,
    realOpacity: vm => (vm.current >= 1 ? MAX_OPACITY : 0)
  },
  async created() {
    //根据id获取
    console.log(this.$route.meta.pid);
    let SOURCES = "";
    const pid = this.$route.meta.pid;

    if (pid === 4) {
      SOURCES = require.context(`@/assets/front/threeD/4/`, false, /\.png$/i);
    } else if ([9, 10, 11].indexOf(pid) !== -1) {
      SOURCES = require.context(`@/assets/front/threeD/9/`, false, /\.png$/i);
    } else if ([14].indexOf(pid) !== -1) {
      SOURCES = require.context(`@/assets/front/threeD/14/`, false, /\.png$/i);
    } else if ([17].indexOf(pid) !== -1) {
      SOURCES = require.context(`@/assets/front/threeD/17/`, false, /\.png$/i);
    } else {
      SOURCES = require.context(`@/assets/front/threeD/12/`, false, /\.png$/i);
    }
    console.log(SOURCES.keys());

    let images = await axios.all(
      SOURCES.keys().map(
        key =>
          new Promise(resolve => {
            let pic = new Image();
            pic.src = SOURCES(key);
            pic.onload = () => {
              let cvs = document.createElement("canvas");
              let ctx = cvs.getContext("2d");
              key = key.match(/\b([^/]+).png$/i)[1];
              cvs.width = WIDTH;
              cvs.height = HEIGHT;
              ctx.drawImage(
                pic,
                0,
                0,
                pic.width,
                pic.height,
                0,
                0,
                WIDTH,
                HEIGHT
              );
              if (key !== "bg") {
                ctx.globalCompositeOperation = "source-atop";
                ctx.globalAlpha = 0.1;
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(0, 0, WIDTH, HEIGHT);
              }
              resolve({ key, pic, cvs, ctx });
            };
          })
      )
    );
    this.bg = images.find(i => i.key === "bg");
    this.parts = images
      .filter(i => i.key !== "bg")
      .sort((a, b) => a.key - b.key);
    this.current++;
  },
  mounted() {
    this.canvas = this.$refs.canvas;
    this.canvas.width = WIDTH;
    this.canvas.height = HEIGHT;
    this.ctx = this.canvas.getContext("2d");
    this.current++;
    requestAnimationFrame(
      function tick() {
        this.opacity =
          Math.abs(this.realOpacity - this.opacity) < STEP
            ? this.realOpacity
            : this.opacity +
            Math.sign(this.realOpacity - this.opacity) * STEP;
        requestAnimationFrame(tick.bind(this));
      }.bind(this)
    );
  },
  watch: {
    current: "draw",
    opacity: "draw"
  },
  methods: {
    draw() {
      if (this.loaded) {
        this.ctx.clearRect(0, 0, WIDTH, HEIGHT);
        this.drawImage(this.bg);
        this.drawMask();
        if (this.current >= 1) {
          this.drawImage(this.parts[this.current - 1]);
        }
      }
    },
    // 绘制背景
    drawImage(image) {
      this.ctx.drawImage(image.cvs, 0, 0);
    },
    // 绘制蒙版
    drawMask() {
      this.ctx.fillStyle = `rgba(0,0,0,${this.opacity})`;
      this.ctx.fillRect(0, 0, WIDTH, HEIGHT);
    },
    // 鼠标滑过
    handleMouseMove(e) {
      if (this.loaded) {
        // 获取坐标
        let rect = this.canvas.getBoundingClientRect();
        let x = ((e.clientX - rect.left) / rect.width) * WIDTH;
        let y = ((e.clientY - rect.top) / rect.height) * HEIGHT;

        // 获取图片像素信息
        this.current = this.parts.reduce(
          (prev, part, idx) =>
            part.ctx.getImageData(x, y, 1, 1).data[3]
              ? idx + 1
              : prev,
          0
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.threeD-page {
  margin: 60px 0px 20px;
  padding-bottom: 30px;
  display: flex;
  justify-content: space-between;

  .tab-title {
    width: 17%;
    padding: 0px;
    margin: 0;

    li {
      color: #214d98;
      font-size: 16px;
      list-style: none;
      // min-height: 65px;
      margin: 0px 0px 10px 0px;

      .s1 {
        min-width: 200px;
        height: 35px;
        line-height: 35px;
        display: block;
        cursor: pointer;
        background: url(../../../assets/front/icon-tab.png) left center no-repeat;

        .num {
          display: inline-block;
          width: 35px;
          height: 35px;
          text-align: center;
          line-height: 35px;
          margin: 0px 10px 0px 0px;
          font-style: normal;
        }
      }

      p {
        display: none;
      }

      dl {
        display: none;
        margin: 0px 0px 0px 38px;

        dd {
          display: inline-block;
          margin: 0px 0px 0px 0.5vw;
          color: #545454;
          font-size: 14px;
          cursor: pointer;

          &:hover {
            color: #214d98;
            font-weight: bold;
          }
        }
      }

      &.active {
        .s1 {
          color: #fff;
          background: url(../../../assets/front/icon-tab1.png) left center no-repeat;
        }

        dl {
          display: block;

          dd {
            color: #214d98;
            font-weight: bold;
          }
        }
      }
    }
  }

  .canvas-box {
    width: 80%;
    position: relative;

    p {
      font-size: 20px;
      color: #464646;
      position: absolute;
      top: -40px;
      margin: 0;
      width: 100%;
      padding-left: 308px;
      box-sizing: border-box;
    }

    canvas {
      width: 100%;
    }
  }
}

@media screen and (max-width: 1024px) {
  .threeD-page {
    display: block;
    margin: 2vw 0;

    .tab-title {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        width: 48%;
        font-size: 4vw;

        .s1 {
          min-width: inherit;
          height: 9vw;
          line-height: 9vw;
          background: url(../../../assets/front/icon-tab.png) left center no-repeat;
          background-size: 100% auto;

          .num {
            width: 9vw;
            height: 9vw;
            line-height: 9vw;
            margin-right: 1vw;
          }
        }

        p {
          display: none;
          margin: 0;
          padding-left: 10vw;
          padding-top: 1vw;
        }

        dl {
          display: none;
        }
      }
    }

    .canvas-box {
      width: 100%;
      padding-bottom: 100px;

      p {
        position: static;
        font-size: 4vw;
        padding-left: 0;
        text-align: center;
        margin-top: 4vw;
        margin-bottom: 2vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/threeD-page.vue